/** Customer-facing brand name (open-right triangle mark). */
export const APP_BRAND = {
  name: 'Everglance',
  prefix: 'Ever',
  accent: 'glance',
  documentTitle: 'Everglance',
  emailBrand: 'Everglance',
  emailBrandReminder: 'Everglance · Reminder',
  openAppLabel: 'Open Everglance',
  // Legal entity for copyright footers, ToS, and contract signature blocks.
  // UI / product name stays `name` ("Everglance"); this is the LLC.
  legalEntity: 'Everglance Education LLC',
  // Year the app was first published (pre-rebrand). Copyright attaches to the
  // work, not the name — the 2025 start holds and the end year auto-updates.
  copyrightStartYear: 2025
}
